import { TextButtonCellRenderer, type TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';

import type { TypeReturnDisposalStatusHistoryApi } from '~/types/receive.types';

/**
 * [입고관리 > 회송/폐기 관리] 상세 모달 > 상태 변경 이력 테이블 컬럼 정의 (Kitchen Table)
 *
 * @note No는 최신순 내림차순(startNo − 행 index). 증빙사진은 claimImageUrls가 있을 때만 [보기] 버튼 노출.
 */
const getReturnDisposalStatusHistoryColumns = ({
  startNo,
  onClickViewClaimImage,
}: {
  startNo: number;
  onClickViewClaimImage: (claimImageUrls: string[]) => void;
}): TypeTableColumn<TypeReturnDisposalStatusHistoryApi>[] => [
  {
    id: 'no',
    header: 'No',
    cell: (info) => startNo - info.row.index,
    meta: { columnFit: true },
  },
  {
    accessorKey: 'inspectionLineStatus',
    header: '처리상태',
    cell: (info) => info.getValue<string>() || '-',
    meta: { columnFit: true },
  },
  {
    accessorKey: 'operatedBy',
    header: '변경주체',
    cell: (info) => info.getValue<string>() || '-',
    meta: { columnFit: true },
  },
  {
    accessorKey: 'reason',
    header: '사유',
    minSize: 240,
    cell: (info) => info.getValue<string>() || '-',
    meta: { flex: true },
  },
  {
    id: 'claimImages',
    header: '증빙사진',
    cell: (info) => {
      const claimImageUrls = info.row.original.claimImageUrls;

      return claimImageUrls?.length ? (
        <TextButtonCellRenderer size="small" onClick={() => onClickViewClaimImage(claimImageUrls)}>
          보기
        </TextButtonCellRenderer>
      ) : (
        '-'
      );
    },
    meta: { columnFit: true, cellStyle: { textAlign: 'center' } },
  },
  {
    accessorKey: 'operatedAt',
    header: '변경시각',
    cell: (info) => formatDate(info.getValue<string>(), DATE_FORMAT.DATE_TIME) ?? '-',
    meta: { columnFit: true },
  },
];

export default getReturnDisposalStatusHistoryColumns;
